// Creates a property that has a getter, setter, private prop, and a listener 
// registration system
//
// Usage:
//
// class User {
//   constructor() {
//     this.initObservableProperties()
//   }

//   initObservableProperties() {
//     ['name', 'age', 'city'].forEach(
//       property => this.createObservableProperty(property)
//     )
//   }
// }
//
// Object.assign(User.prototype, hasObservableProperties);

// let u = new User

// u.registerPropertyListener( 'name', 
//   (old_val, new_val) => { 
//     alert(`I love the new val ${new_val}`) 
//   }
// )

// u.registerPropertyListener( 'age', 
//   (old_val, new_val) => { 
//     if(new_val < 10) {
//       alert('Aw yr so young') 
//     } else {
//       alert('Im older than you!') 
//     }
//   }
// )


const HasObservableProperties = {
  createObservableProperty(property, initial_val) {
    if(!this.propertyListeners) this.propertyListeners = {}

    this.propertyListeners[property] = []
    let private_name = `#${property}` //#makes private

    Object.defineProperty(this, property, {
      enumerable: false,
      get: () => this[private_name],
      set: (val) => {
        this.notifyOfSet(property, this[private_name], val)
        this[private_name] = val
      }
    })

    this[property] = initial_val
  },
  
  notifyOfSet(property, old_val, new_val) {
    this.propertyListeners[property].forEach(
      listener => {
        listener(old_val, new_val)
      }
    )
  },
  
  // note: since this is called inside setter, the new val is only available
  // throught the params, as the object prop is not set until setter returns
  registerPropertyListener(property, listener) {
    this.propertyListeners[property].push(listener)
  },
  

  removePropertyListener(property, listener) {
    this.propertyListeners[property] = this.propertyListeners[property].reduce( 
      (remaining_listeners, registered_listener) => {
        if(registered_listener != listener) remaining_listeners.push(registered_listener)
        return remaining_listeners
      }, 
      []
    )
  }
}

export default HasObservableProperties;